export default __webpack_public_path__ + "static/media/CORE_HOO.c80b09e5.png";